var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-card',{attrs:{"shadow":"never"}},[_c('h2',{staticClass:"text-left"},[_vm._v("All Customer")]),_c('el-row',[_c('all-customer-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }